import $ from "jquery";
import Slick from "slick-carousel";

class HomePage {

    constructor() {

        this.slider = "#homepage__slider";

        this.handleSlider();
    }

    handleSlider() {
        $(document).ready(() => {
            $(this.slider).slick({
                dots: true,
                infinite: true,
                speed: 300,
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                adaptiveHeight: true,
                prevArrow: '<div class="homepage__banner-prev"></div>',
                nextArrow: '<div class="homepage__banner-next"></div>',

            });
        });
    }

}

export default new HomePage();
